import React from "react";

export default function Marquee({ items }) {
  const loop = [...items, ...items, ...items];
  return (
    <section data-testid="marquee" className="border-y border-line bg-ink py-6 md:py-8 overflow-hidden">
      <div className="flex whitespace-nowrap marquee-track">
        {loop.map((w, i) => (
          <div key={i} className="flex items-center gap-10 px-6">
            <span className="font-display text-3xl md:text-5xl tracking-wide text-bone/90 uppercase">{w}</span>
            <span className="text-leaf font-display text-3xl md:text-5xl">/</span>
          </div>
        ))}
      </div>
    </section>
  );
}
